import React from "react";
import { Icon, Popup, Card } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { capitalize } from "../../app_shared_functions";
import AppIcon from "./AppIcon";
import { normalizeTitle } from "../helper";

const CardPopup = ({ type }: { type: string }) => {
  return (
    <div>
      <p className={type === "Partner" ? "color-black" : "color-gray-light"}>
        <b>Partner: </b>
        <br />
        Trusted Cleura partners providing value added services with reliable
        support.
      </p>
      <p className={type === "OpenSource" ? "color-black" : "color-gray-light"}>
        <b>OpenSource: </b>
        <br />
        Software and technologies contributed through community driven
        innovation, flexibility, transparency and support.
      </p>
    </div>
  );
};

const formatServiceType = (serviceType: string): string => {
  return serviceType
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

type MarketplaceCardHeaderProps = {
  app: {
    title: string;
    serviceType: string;
  };
};

const MarketplaceCardHeader: React.FC<MarketplaceCardHeaderProps> = ({
  app,
}) => {
  const history = useHistory();

  const handleInstallClick = () => {
    history.push(`/marketplace/${app.title.toLowerCase()}`);
  };

  return (
    <Card.Header className="flex">
      <AppIcon title={app.title} />
      <div className="margin-left flex-1 flex flex-column">
        <h1 className="margin-bottom-00">{app.title}</h1>
        <h5 className="margin-top-00">
          <React.Fragment>
            {formatServiceType(app.serviceType)}
            <Popup
              trigger={
                <Icon name="question circle" className="margin-left-half" />
              }
              content={<CardPopup type={app.serviceType} />}
            />
          </React.Fragment>
        </h5>
      </div>
      <button
        className="button button--green bottom__0 float-right"
        onClick={handleInstallClick}
      >
        <span>View</span>
      </button>
    </Card.Header>
  );
};

export default MarketplaceCardHeader;
